import React from 'react'
import { twMerge } from 'tailwind-merge'

interface ImageCircleProps {
  path?: string
  className?: string
  onClick?: () => void
  isActive?: boolean
}

export const ImageCircle = ({
  className,
  path,
  onClick,
  isActive = false,
}: ImageCircleProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={twMerge(
        'h-5 w-5 cursor-pointer rounded-2xl border border-border200 bg-center bg-cover transition hover:border-borderInteractive',
        'flex items-center justify-center outline-borderInteractive/20 focus:outline-4',
        isActive && 'border-borderInteractive outline-4',
        className,
      )}
      style={{
        ...(path ? { backgroundImage: `url(${path})` } : {}),
      }}
    >
      <span
        className={twMerge(
          'h-[1px] w-full -rotate-45 bg-iconError',
          path ? 'hidden' : '',
        )}
      />
    </button>
  )
}
